import React, { FC } from 'react';
import useI18n from '../../../../i18n/hooks/useI18n';
import HeaderValueList from '../../../../commons/components/HeaderValueList';
import { ReturnsSellerBuyerInfo } from '../../../../../typings/returns';

interface UserDetailsProps {
  userData: ReturnsSellerBuyerInfo;
}

const UserDetails: FC<UserDetailsProps> = ({ userData }) => {
  const i18n = useI18n();

  const userDataItemsList = [
    {
      header: i18n`dlv_returns_details_name`,
      value: userData.name,
    },
    {
      header: i18n`dlv_returns_details_phone`,
      value: userData.phone,
      isImportant: true,
    },
  ];

  return (
    <div data-cy="returns-details-user-details">
      <HeaderValueList listItems={userDataItemsList} />
    </div>
  );
};

export default UserDetails;
